import { autoinject, transient } from "aurelia-dependency-injection";
import { computedFrom } from "aurelia-binding";
import { useView } from "aurelia-framework";

@autoinject
@transient()
@useView('views/pages/modules/rfq/plugins/rfq-processing/rfq-processing.html')
export class RfqProcessing {

    canSubmit: boolean = false;
    formHasMultiplePages: boolean = false;
    currentVM: string;
    
    //Change subtitle text based on the product
    @computedFrom("currentVM")
    get subTitleText(){
        if(this.currentVM == 'rfq-add-rightship-inspection'){
            return 'It is now in process, and you will be contacted via email shortly.'
        }
        return 'It is now in process and a quote will be emailed to you shortly.'
    }

    activate(args: { currentVM: string }){
        this.currentVM = args.currentVM;
    }
}